import {
	GotoCleanLabelProducts,
	GotoKehe,
	GotoMinorityProducts,
	GotoNewtoMarketProducts,
	GotoNextyProducts,
	GotoPrivateProducts
} from '../Cta/Cta';
// import { SeeAll } from '../SeeAll/SeeAll';

export const ForSmallDesktops = () => {
	return (
		<div className='newtopiaSmallScreen'>
			<div className='cardContainer'>
				<div className='topCardContainer'>
					<div className='cardPrivate'>
						<GotoPrivateProducts />
					</div>
					<div className='cardLabel'>
						<GotoCleanLabelProducts />
					</div>
					<div className='cardNexty'>
						<GotoNextyProducts />
					</div>
				</div>
				<div className='midCardContainer'>
					<div className='midCard'>
						<GotoNewtoMarketProducts />
					</div>
				</div>
				<div className='bottomCardContainer'>
					<div className='cardMinority'>
						<GotoMinorityProducts />
					</div>
					<div className='cardKehe'>
						<GotoKehe />
					</div>
				</div>
				<div className='newtopiawave'></div>
			</div>
			<div className='footer'></div>
		</div>
	);
};
